import { Action } from 'redux';

export const QB_INIT_REQUEST = 'QB_INIT_REQUEST';
export const QB_INIT_SUCCESS = 'QB_INIT_SUCCESS';
export const QB_INIT_FAILURE = 'QB_INIT_FAILURE';
export const JANUS_INIT_REQUEST = 'JANUS_INIT_REQUEST';
export const JANUS_INIT_SUCCESS = 'JANUS_INIT_SUCCESS';
export const JANUS_INIT_FAILURE = 'JANUS_INIT_FAILURE';
export const QB_DISPOSE_REQUEST = 'QB_DISPOSE_REQUEST';
export const QB_DISPOSE_SUCCESS = 'QB_DISPOSE_SUCCESS';
export const QB_DISPOSE_FAILURE = 'QB_DISPOSE_FAILURE';
// multiparty conferencing client actions
export const CLIENT_CREATE_SESSION_REQUEST = 'CLIENT_CREATE_SESSION_REQUEST';
export const CLIENT_CREATE_SESSION_SUCCESS = 'CLIENT_CREATE_SESSION_SUCCESS';
export const CLIENT_CREATE_SESSION_FAILURE = 'CLIENT_CREATE_SESSION_FAILURE';
export const CLIENT_DESTROY_SESSION_REQUEST = 'CLIENT_DESTROY_SESSION_REQUEST';
export const CLIENT_DESTROY_SESSION_SUCCESS = 'CLIENT_DESTROY_SESSION_SUCCESS';
export const CLIENT_DESTROY_SESSION_FAILURE = 'CLIENT_DESTROY_SESSION_FAILURE';
export const CLIENT_ATTACH_PLUGIN_REQUEST = 'CLIENT_ATTACH_PLUGIN_REQUEST';
export const CLIENT_ATTACH_PLUGIN_SUCCESS = 'CLIENT_ATTACH_PLUGIN_SUCCESS';
export const CLIENT_ATTACH_PLUGIN_FAILURE = 'CLIENT_ATTACH_PLUGIN_FAILURE';
export const CLIENT_DETACH_PLUGIN_REQUEST = 'CLIENT_DETACH_PLUGIN_REQUEST';
export const CLIENT_DETACH_PLUGIN_SUCCESS = 'CLIENT_DETACH_PLUGIN_SUCCESS';
export const CLIENT_DETACH_PLUGIN_FAILURE = 'CLIENT_DETACH_PLUGIN_FAILURE';
export const LIST_PARTICIPANTS_REQUEST = 'LIST_PARTICIPANTS_REQUEST';
export const LIST_PARTICIPANTS_SUCCESS = 'LIST_PARTICIPANTS_SUCCESS';
export const LIST_PARTICIPANTS_FAILURE = 'LIST_PARTICIPANTS_FAILURE';
export const TOGGLE_MUTE_AUDIO_REQUEST = 'TOGGLE_MUTE_AUDIO_REQUEST';
export const TOGGLE_MUTE_AUDIO_SUCCESS = 'TOGGLE_MUTE_AUDIO_SUCCESS';
export const TOGGLE_MUTE_AUDIO_FAILURE = 'TOGGLE_MUTE_AUDIO_FAILURE';
export const TOGGLE_MUTE_VIDEO_REQUEST = 'TOGGLE_MUTE_VIDEO_REQUEST';
export const TOGGLE_MUTE_VIDEO_SUCCESS = 'TOGGLE_MUTE_VIDEO_SUCCESS';
export const TOGGLE_MUTE_VIDEO_FAILURE = 'TOGGLE_MUTE_VIDEO_FAILURE';
export const TOGGLE_SCREENSHARE_REQUEST = 'TOGGLE_SCREENSHARE_REQUEST';
export const TOGGLE_SCREENSHARE_SUCCESS = 'TOGGLE_SCREENSHARE_SUCCESS';
export const TOGGLE_SCREENSHARE_FAILURE = 'TOGGLE_SCREENSHARE_FAILURE';
export const ICE_RESTART_REQUEST = 'ICE_RESTART_REQUEST';
export const ICE_RESTART_SUCCESS = 'ICE_RESTART_SUCCESS';
export const ICE_RESTART_FAILURE = 'ICE_RESTART_FAILURE';
export const CLIENT_JOIN_REQUEST = 'CLIENT_JOIN_REQUEST';
export const CLIENT_JOIN_SUCCESS = 'CLIENT_JOIN_SUCCESS';
export const CLIENT_JOIN_FAILURE = 'CLIENT_JOIN_FAILURE';
export const CLIENT_LEAVE_REQUEST = 'CLIENT_LEAVE_REQUEST';
export const CLIENT_LEAVE_SUCCESS = 'CLIENT_LEAVE_SUCCESS';
export const CLIENT_LEAVE_FAILURE = 'CLIENT_LEAVE_FAILURE';
// multiparty conferencing client events
export const LOCAL_STREAM = 'LOCAL_STREAM';
export const REMOTE_STREAM = 'REMOTE_STREAM';
export const PARTICIPANT_JOINED = 'PARTICIPANT_JOINED';
export const PARTICIPANT_LEFT = 'PARTICIPANT_LEFT';
export const CONFERENCING_CLIENT_ERROR = 'CONFERENCING_CLIENT_ERROR';

export type QBInitActionParams = {
  appId: string;
  authKey: string;
  authSecret: string;
  accountKey: string;
  config: any;
};

export interface QBInitRequestAction extends Action {
  type: typeof QB_INIT_REQUEST;
  payload: QBInitActionParams;
}

export interface QBInitSuccessAction extends Action {
  type: typeof QB_INIT_SUCCESS;
}

export interface QBInitFailureAction extends Action {
  type: typeof QB_INIT_FAILURE;
  error: string;
}

export interface JanusInitRequestAction extends Action {
  type: typeof JANUS_INIT_REQUEST;
  payload: { region: string; then?: (action: JanusInitSuccessAction) => void };
}

export interface JanusInitSuccessAction extends Action {
  type: typeof JANUS_INIT_SUCCESS;
  payload: { client: QBVideoConferencingClient };
}

export interface JanusInitFailureAction extends Action {
  type: typeof JANUS_INIT_FAILURE;
  error: string;
}

export interface CreateSessionRequestAction extends Action {
  type: typeof CLIENT_CREATE_SESSION_REQUEST;
  payload: { then?: (action: CreateSessionSuccessAction) => void };
}

export interface CreateSessionSuccessAction extends Action {
  type: typeof CLIENT_CREATE_SESSION_SUCCESS;
}

export interface CreateSessionFailureAction extends Action {
  type: typeof CLIENT_CREATE_SESSION_FAILURE;
  error: string;
}

export interface DestroySessionRequestAction extends Action {
  type: typeof CLIENT_DESTROY_SESSION_REQUEST;
  payload: {
    then?: (action: DestroySessionSuccessAction) => void;
    catch?: (reason?: any) => void;
  };
}

export interface DestroySessionSuccessAction extends Action {
  type: typeof CLIENT_DESTROY_SESSION_SUCCESS;
}

export interface DestroySessionFailureAction extends Action {
  type: typeof CLIENT_DESTROY_SESSION_FAILURE;
  error: string;
}

export interface ClientAttachPluginRequestAction extends Action {
  type: typeof CLIENT_ATTACH_PLUGIN_REQUEST;
  payload: {
    isRemote: boolean;
    userId: any;
    then?: (action: ClientAttachPluginSuccessAction) => void;
  };
}

export interface ClientAttachPluginSuccessAction extends Action {
  type: typeof CLIENT_ATTACH_PLUGIN_SUCCESS;
  payload: { plugin: PluginHandleEmitter; isRemote: boolean; userId: any };
}

export interface ClientAttachPluginFailureAction extends Action {
  type: typeof CLIENT_ATTACH_PLUGIN_FAILURE;
  error: string;
}

export interface ClientDetachPluginRequestAction extends Action {
  type: typeof CLIENT_DETACH_PLUGIN_REQUEST;
  payload: {
    then?: (action: ClientDetachPluginSuccessAction) => void;
    catch?: (reason?: any) => void;
  };
}

export interface ClientDetachPluginSuccessAction extends Action {
  type: typeof CLIENT_DETACH_PLUGIN_SUCCESS;
}

export interface ClientDetachPluginFailureAction extends Action {
  type: typeof CLIENT_DETACH_PLUGIN_FAILURE;
  error: string;
}

export interface ClientJoinRequestAction extends Action {
  type: typeof CLIENT_JOIN_REQUEST;
  payload: { roomId: string; then?: (action: ClientJoinSuccessAction) => void };
}

export interface ClientJoinSuccessAction extends Action {
  type: typeof CLIENT_JOIN_SUCCESS;
}

export interface ClientJoinFailureAction extends Action {
  type: typeof CLIENT_JOIN_FAILURE;
  error: string;
}

export interface ClientLeaveRequestAction extends Action {
  type: typeof CLIENT_LEAVE_REQUEST;
  payload: {
    then?: (action: ClientLeaveSuccessAction) => void;
    catch?: (reason?: any) => void;
  };
}

export interface ClientLeaveSuccessAction extends Action {
  type: typeof CLIENT_LEAVE_SUCCESS;
}

export interface ClientLeaveFailureAction extends Action {
  type: typeof CLIENT_LEAVE_FAILURE;
  error: string;
}

export interface ListRoomParticipantsRequestAction extends Action {
  type: typeof LIST_PARTICIPANTS_REQUEST;
  payload: { then?: (action: ListRoomParticipantsSuccessAction) => void };
}

export interface ListRoomParticipantsSuccessAction extends Action {
  type: typeof LIST_PARTICIPANTS_SUCCESS;
  payload: Participant[];
}

export interface ListRoomParticipantsFailureAction extends Action {
  type: typeof LIST_PARTICIPANTS_FAILURE;
  error: string;
}

export interface ToggleMuteAudioRequestAction extends Action {
  type: typeof TOGGLE_MUTE_AUDIO_REQUEST;
}

export interface ToggleMuteAudioSuccessAction extends Action {
  type: typeof TOGGLE_MUTE_AUDIO_SUCCESS;
  payload: { muted: boolean };
}

export interface ToggleMuteAudioFailureAction extends Action {
  type: typeof TOGGLE_MUTE_AUDIO_FAILURE;
  error: string;
}

export interface ToggleMuteVideoRequestAction extends Action {
  type: typeof TOGGLE_MUTE_VIDEO_REQUEST;
}

export interface ToggleMuteVideoSuccessAction extends Action {
  type: typeof TOGGLE_MUTE_VIDEO_SUCCESS;
  payload: { muted: boolean };
}

export interface ToggleMuteVideoFailureAction extends Action {
  type: typeof TOGGLE_MUTE_VIDEO_FAILURE;
  error: string;
}

export interface ToggleScreenSharingRequestAction extends Action {
  type: typeof TOGGLE_SCREENSHARE_REQUEST;
}

export interface ToggleScreenSharingRequestSuccess extends Action {
  type: typeof TOGGLE_SCREENSHARE_SUCCESS;
  payload: { enabled: boolean };
}

export interface ToggleScreenSharingFailureAction extends Action {
  type: typeof TOGGLE_SCREENSHARE_FAILURE;
  error: string;
}

export interface IceRestartRequest extends Action {
  type: typeof ICE_RESTART_REQUEST;
  payload: { isRemote: boolean; userId?: number };
}

export interface IceRestartSuccess extends Action {
  type: typeof ICE_RESTART_SUCCESS;
}

export interface IceRestartFailure extends Action {
  type: typeof ICE_RESTART_FAILURE;
  error: string;
}

export interface QBDisposeRequestAction extends Action {
  type: typeof QB_DISPOSE_REQUEST;
}

export interface QBDisposeSuccessAction extends Action {
  type: typeof QB_DISPOSE_SUCCESS;
}

export interface QBDisposeFailureAction extends Action {
  type: typeof QB_DISPOSE_FAILURE;
  error: string;
}

export interface LocalStreamEvent extends Action {
  type: typeof LOCAL_STREAM;
  payload: { stream: MediaStream };
}

export interface RemoteStreamEvent extends Action {
  type: typeof REMOTE_STREAM;
  payload: { stream: MediaStream; userId: number };
}

export interface ParticipantJoinedEvent extends Action {
  type: typeof PARTICIPANT_JOINED;
  payload: {
    audio_codec: string;
    display?: string;
    id: number;
    talking: boolean;
    video_codec: string;
  };
}

export interface ParticipantLeftEvent extends Action {
  type: typeof PARTICIPANT_LEFT;
  payload: { userId: number; userDisplayName?: string };
}

export interface ConferencingClientError extends Action {
  type: typeof CONFERENCING_CLIENT_ERROR;
  error: string;
}

export type ConferencingClientEvent =
  | LocalStreamEvent
  | RemoteStreamEvent
  | ParticipantJoinedEvent
  | ParticipantLeftEvent
  | ConferencingClientError;

export type QBAction =
  | QBInitRequestAction
  | QBInitSuccessAction
  | QBInitFailureAction
  | JanusInitRequestAction
  | JanusInitSuccessAction
  | JanusInitFailureAction
  | CreateSessionRequestAction
  | CreateSessionSuccessAction
  | CreateSessionFailureAction
  | DestroySessionRequestAction
  | DestroySessionSuccessAction
  | DestroySessionFailureAction
  | ClientAttachPluginRequestAction
  | ClientAttachPluginSuccessAction
  | ClientAttachPluginFailureAction
  | ClientDetachPluginRequestAction
  | ClientDetachPluginSuccessAction
  | ClientDetachPluginFailureAction
  | ClientJoinRequestAction
  | ClientJoinSuccessAction
  | ClientJoinFailureAction
  | ClientLeaveRequestAction
  | ClientLeaveSuccessAction
  | ClientLeaveFailureAction
  | ListRoomParticipantsRequestAction
  | ListRoomParticipantsSuccessAction
  | ListRoomParticipantsFailureAction
  | ToggleMuteAudioRequestAction
  | ToggleMuteAudioSuccessAction
  | ToggleMuteAudioFailureAction
  | ToggleMuteVideoRequestAction
  | ToggleMuteVideoSuccessAction
  | ToggleMuteVideoFailureAction
  | ToggleScreenSharingRequestAction
  | ToggleScreenSharingRequestSuccess
  | ToggleScreenSharingFailureAction
  | QBDisposeRequestAction
  | QBDisposeSuccessAction
  | QBDisposeFailureAction;
